import * as button from '@/common/manager/button';
import { ButtonPosition } from '@/common/manager/position/button-position';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { ValidatorPosition } from '@/common/manager/position/validator-position';
import * as util from '@/common/util/util';
import { registerValidator } from '@/common/manager/validator';
import * as filterItem from '@/common/manager/filter-item';
import { makeRequest, transRequestConfigToRemote } from '@/common/util/request';
import { calculateTextExprValue, dialogClose, dialogOpen, tableLoad, } from '@/common/util/util';
import * as hoc from '@/common/util/hoc';
/**
 * 通用的辅助方法，供 L2 业务组件使用，挂载在 window 上
 */
window.cnLowCodeUtils = {
    ...getCommonOpenUtil(),
};
export function getCommonOpenUtil() {
    return {
        /**
         * 【运行时】发请求
         */
        makeRequest,
        /**
         * 【运行时】获取配置表达式的值
         */
        getExpressionValue: calculateTextExprValue,
        /**
         * 【运行时】将低码 API 配置转换成 cn-ui service 配置对象
         */
        transformRequestConfigToRemote: transRequestConfigToRemote,
        /**
         * 【运行时】表达式相关方法
         */
        expression: {
            /**
             * 【运行时】获取配置表达式的值
             */
            getExpressionValue: calculateTextExprValue,
            /**
             * 【运行时】将低码 API 配置转换成 cn-ui service 配置对象
             */
            transformRequestConfigToRemote: transRequestConfigToRemote,
        },
        /**
         * 【运行时】请求相关方法
         */
        request: {
            /**
             * 【运行时】发请求
             */
            makeRequest,
        },
        /**
         * 【运行时】弹窗相关方法
         */
        dialog: {
            /**
             * 【运行时】打开弹窗
             */
            open: dialogOpen,
            /**
             * 【运行时】关闭弹窗
             */
            close: dialogClose,
        },
        /**
         * 表格相关方法
         */
        table: {
            /**
             * 【运行时】打开弹窗
             */
            load: tableLoad,
        },
        /**
         * 按钮相关方法
         */
        button,
        /**
         * 枚举
         */
        enumMap: {
            ButtonPosition,
            DisplayPosition,
            ValidatorPosition,
        },
        /**
         * 工具类
         */
        util,
        /**
         * 事件回调类，运行时不应透出，此处仅兼容历史扩展代码
         */
        event: {
            componentMap: {},
            registerEvent: () => { },
        },
        /**
         * hoc
         */
        hoc,
        /**
         * filterItem
         */
        filterItem: {
            ...filterItem,
            registerValidator,
        },
    };
}
